import React, { useContext, useEffect } from 'react';
import { Breadcrumb } from '@thd-olt-component-react/etch-widgets/dist/components/etch1/Etch1';
import { Col, Row, Button } from '@thd-olt-component-react/core-ui';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { BackToTop } from '@thd-olt-component-react/back-to-top';
import { Metadata } from '@thd-olt-component-react/metadata';
import classnames from 'classnames';
import { imageBaseUrl } from '../../constants';
import { PrivacyHeader } from './PrivacyHeader';
import { PrivacyMetadata } from './PrivacyMetadata';
import './Home.scss';

export const Home = () => {

  const { channel } = useContext(ExperienceContext);

  useEffect(() => {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('exerciseMyPrivacyRights.static.page-load', {
      pageName: 'privacy and security center',
      pageType: 'content',
      primaryCategory: 'privacy and security center',
      subCategory1: 'privacy and security center',
      subCategory2: 'privacy and security center'
    });
  });

  const navigate = (link) => {
    window.location.href = link;
    return true;
  };

  const metadata = {
    title: 'Privacy & Security Center – The Home Depot',
    description: 'The Privacy & Security Center is designed to help you learn about the information '
      + 'The Home Depot collects and how we use and share it',
    canonical: 'https://www.homedepot.com/privacy/overview'
  };

  const anchorClassname = classnames('white margin-20 ', { 'privacy-home--anchor-mobile': channel === 'mobile' });

  return (
    <div style={{ backgroundColor: '#F5F5F5' }} className="privacy-home">
      <Metadata>
        <PrivacyMetadata
          title={metadata.title}
          description={metadata.description}
          canonical={metadata.canonical}
        />
      </Metadata>
      <div className="container">
        <div className="cdg-content--header">
          <Row>
            <Col>
              <Breadcrumb breadCrumbs={[
                {
                  url: '',
                  label: 'Privacy & Security Center'
                }]}
              />
            </Col>
          </Row>

        </div>

        <PrivacyHeader overviewActive />

        <div className="cdg-content--body">
          <Row className="white margin-20">
            <Row>

              {channel === 'mobile'
            && (
              <Col md="6" className="remove-padding">
                <img
                  id="mobileHeaderImage"
                  width="720"
                  height="600"
                  alt="Privacy At Homedepot"
                  src={imageBaseUrl + '/privacy-and-security-homepage-hero.jpg'}
                  style={{ width: '100%' }}
                />
              </Col>
            )}
              <Col md="6" className="content-summary">
                <h1>Privacy at The Home Depot</h1>
                <br />
                <p style={{ fontSize: '18px' }}>At The Home Depot, we appreciate that you trust us
                  with your personal information, and we’re committed to using your information in
                  ways that create value for you. Every day, we are guided by our principles,
                  and we work hard to earn and keep your trust.
                </p>
                <br />
                <h2 style={{ marginBottom: '10px' }}><b>Our Privacy Principles</b></h2>
                <b>Transparency</b>
                <p className="principle-verbiage-margins">We&apos;re open and honest with you about
                  how we use and disclose your personal information.
                </p>
                <b>Control</b>
                <p className="principle-verbiage-margins">We give you tools to help you exercise your rights.</p>
                <b>Security</b>
                <p className="principle-verbiage-margins">We use industry-standard means to protect our websites and
                  your information.
                </p>
                <p style={{ marginTop: '20px' }}>With these principles in mind, the Privacy & Security Center
                  is designed to help you learn about what we do with your data
                  and provide you with tools to take action.
                </p>
                <br />
                <a href="#ToolsToExerciseYourPrivacy" style={{ fontWeight: 'bold' }}>
                  Explore Our Privacy Tools
                  {/* eslint-disable-next-line @mizdra/layout-shift/require-size-attributes */}
                  <img
                    src={imageBaseUrl + '/caret-orange.svg'}
                    alt=""
                    style={{ margin: '0 0 1px 5px' }}
                  />
                </a>
              </Col>

              {channel !== 'mobile'
            && (
              <Col md="6" className="remove-padding">
                <img
                  id="defaultHeaderImage"
                  width="720"
                  height="600"
                  alt="Privacy At Homedepot"
                  src={imageBaseUrl + '/privacy-and-security-homepage-hero.jpg'}
                  style={{ width: '100%', height: '100%' }}
                />
              </Col>
            )}

            </Row>
          </Row>

          <Row className="white margin-20">
            <Row>
              <Col className="content-title">
                <h2>Understanding Your Data</h2>
              </Col>
            </Row>
            <Col
              md="4"
              sm="4"
              xs="4"
              className={classnames('content-summary', { 'privacy-home--content': channel !== 'mobile' })}
            >
              <img
                height="100"
                width="100"
                alt="Privacy ToolBox"
                src={imageBaseUrl + '/OnlinePrivacy_Icon_InformationCollected.svg'}
                style={{ margin: '0 auto', width: '50%', display: 'block' }}
              />
              <h3><b>How We Collect Information</b></h3>
              <p>We collect your information when you visit our stores, contact us, or interact with our digital
                offerings. We also collect information from third parties that help us understand your interests
                and preferences better. This allows us to provide the most seamless and personalized shopping experience
                possible.
              </p>
              <br />
              <div className={channel !== 'mobile' ? 'privacy-home--paragraph' : ''}>
                Examples of information collected:
                <ul>
                  <li>Personal information, such as name, email address, and phone number</li>
                  <li>Financial information, such as payment methods</li>
                  <li>Location information</li>
                  <li>Purchase history, including products or services you liked and reviews you submitted</li>
                  <li>Demographic and preference information including interests and other characteristics</li>
                  <li>Internet activity, such as browsing history and search history</li>
                </ul>
                <br />
                <p>
                  We may also collect some information that may be considered sensitive under certain privacy laws,
                  such as account login credentials, race/ethnicity, government identification numbers,
                  biometrics, and precise geo-location.
                </p>
              </div>
              <Button
                onClick={() => navigate('/privacy/privacy-and-security-at-a-glance#WhatInformationDoWeCollect')}
                className={channel === 'mobile' ? 'cdg-button--mobile' : 'smaller-btn privacy-home--btn'}
                outline
              >Discover More
              </Button>
            </Col>
            <Col
              md="4"
              sm="4"
              xs="4"
              className={classnames('content-summary', { 'privacy-home--content': channel !== 'mobile' })}
            >
              <img
                height="100"
                width="100"
                alt="Privacy ToolBox"
                src={imageBaseUrl + '/OnlinePrivacy_Icon_InformationShared.svg'}
                style={{ margin: '0 auto', width: '50%', display: 'block' }}
              />
              <h3><b>How We Disclose Your Information</b></h3>
              <p>We are selective about who we disclose your information with, and only disclose data
                with select third parties for business or legal reasons. We may disclose information
                that does not directly identify you (such as your device identifier, IP address,
                or other information associated with your online browsing activities) with select
                third parties for their and our advertising and marketing efforts.
              </p>
              <br />
              <p className={channel !== 'mobile' ? 'privacy-home--paragraph' : ''}>
                Examples of who information is disclosed with:
                <ul>
                  <li>Delivery partners</li>
                  <li>Security and payment providers</li>
                  <li>Shipping and mailing vendors</li>
                  <li>Advertising partners</li>
                  <li>Third-party companies</li>
                  <li>Marketing and advertising companies</li>
                </ul>
              </p>
              <Button
                onClick={() => navigate('/privacy/privacy-and-security-at-a-glance#HowDoWeDiscloseInformation')}
                className={channel === 'mobile' ? 'cdg-button--mobile' : 'smaller-btn privacy-home--btn'}
                outline
              >Explore More
              </Button>
            </Col>
            <Col
              md="4"
              sm="4"
              xs="4"
              className={classnames('content-summary', { 'privacy-home--content': channel !== 'mobile' })}
            >
              <img
                height="100"
                width="100"
                alt="Privacy ToolBox"
                src={imageBaseUrl + '/OnlinePrivacy_Icon_InformationUsed.svg'}
                style={{ margin: '0 auto', width: '50%', display: 'block' }}
              />
              <h3><b>How We Use Your Information</b></h3>
              <p>We use the information you provide us in innovative ways to improve your experience,
                process your information, and keep things running smoothly.
              </p>
              <br />
              <p className={channel !== 'mobile' ? 'privacy-home--paragraph' : ''}>
                Examples of how information is used:
                <ul>
                  <li>Fulfill and deliver orders</li>
                  <li>Process a return</li>
                  <li>Personalize the content in our digital services</li>
                  <li>Recommend relevant products and services</li>
                  <li>Delivering marketing communications and advertising</li>
                  <li>Prevent fraud</li>
                </ul>
              </p>
              <Button
                onClick={() => navigate('/privacy/privacy-and-security-at-a-glance#HowDoWeUseInformation')}
                className={channel === 'mobile' ? 'cdg-button--mobile' : 'smaller-btn privacy-home--btn'}
                outline
              >Learn More
              </Button>
            </Col>
          </Row>
          <Row id="ToolsToExerciseYourPrivacy" className={anchorClassname}>
            <Row>
              <Col className="content-title">
                <h2>Tools to Exercise Your Privacy</h2>
              </Col>
            </Row>
            <Row>
              <Col md="2" sm="2" xs="4">
                {/* eslint-disable-next-line @mizdra/layout-shift/require-size-attributes */}
                <img
                  height="100"
                  width="100"
                  alt="Submit Request"
                  src={imageBaseUrl + '/OnlinePrivacy_Icon_SubmitPrivacyRequest.svg'}
                  style={{ margin: '0 auto', width: '50%', display: 'block' }}
                />
              </Col>
              <Col md="10" sm="10" xs="5" className="content-summary">
                <h3><b>Submit a Privacy Request</b></h3>
                <p>You may submit a privacy request to:</p>
                <ul>
                  <li>Review, correct, or delete the personal information we collect</li>
                  <li>
                    Opt out of having your personal information sold for valuable consideration
                    or for being shared or used for certain targeted advertising
                  </li>
                  <li>Limit the use of certain sensitive personal information</li>
                </ul>
                <Button
                  onClick={() => navigate('/privacy/Exercise-My-Privacy-Rights')}
                  className={channel === 'mobile' ? 'cdg-button--mobile' : 'smaller-btn'}
                  outline
                >Submit Request
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md="2" sm="2" xs="4">
                {/* eslint-disable-next-line @mizdra/layout-shift/require-size-attributes */}
                <img
                  height="100"
                  width="100"
                  alt="Manage Preferences"
                  src={imageBaseUrl + '/OnlinePrivacy_Icon_ManageMarketingPreferences.svg'}
                  style={{ margin: '0 auto', width: '50%', display: 'block' }}
                />
              </Col>
              <Col md="10" sm="10" xs="5" className="content-summary">
                <h3><b>Manage Your Marketing Preferences</b></h3>
                <p>Review and manage how your personal information is used for our direct marketing purposes,
                  such as emails, calls, text messages, direct mail, and catalog mailings.
                </p>
                <Button
                  onClick={() => navigate('/privacy/MyPreferenceCenter')}
                  className={channel === 'mobile' ? 'cdg-button--mobile' : 'smaller-btn'}
                  outline
                >Manage Preferences
                </Button>
              </Col>
            </Row>
          </Row>
          <Row className="margin-20" />
          <BackToTop />
        </div>
      </div>
    </div>
  );
};

Home.propTypes = {};

Home.defaultProps = {};
